// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__18l2V","bigColWidth":"Table_bigColWidth__27Q8w","biggerColWidth":"Table_biggerColWidth__3z54t","row":"Table_row__37g0T","col":"Table_col__3pORM"};